var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNounSoundOff3408642(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50,2.5C23.8,2.5,2.5,23.8,2.5,50c0,26.2,21.3,47.5,47.5,47.5c26.2,0,47.5-21.3,47.5-47.5C97.5,23.8,76.2,2.5,50,2.5z      M81.5,77.4l-7.6-7.6c-0.4,0.4-0.7,0.8-1.1,1.2c-1.1,1.1-2.5,1.7-4,1.8l8.7,8.7C70,87.8,60.5,91.7,50,91.7C27,91.7,8.3,73,8.3,50     c0-10.5,3.9-20,10.3-27.4L29.9,34H34l2-2.1L22.6,18.5C30,12.2,39.5,8.3,50,8.3C73,8.3,91.7,27,91.7,50     C91.7,60.5,87.9,70,81.5,77.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9,40.4c-0.6-0.7-1.7-0.7-2.4-0.1l-1.7,1.8c-0.5,0.6-0.6,1.5-0.1,2.1c1.3,1.6,2,3.7,2,5.8c0,2.1-0.7,4.2-2,5.8     c-0.5,0.6-0.4,1.5,0.1,2.1l1.7,1.8c0.7,0.7,1.8,0.7,2.4-0.1c2.2-2.7,3.4-6,3.4-9.6C66.3,46.5,65.1,43.1,62.9,40.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1,32.2L65.5,34c-0.6,0.6-0.5,1.6,0,2.2c3.6,3.7,5.6,8.6,5.6,13.8c0,5.1-2,10.1-5.6,13.8c-0.6,0.6-0.6,1.6,0,2.2     l1.6,1.8c0.6,0.7,1.7,0.7,2.4,0c4.6-4.7,7.3-11.1,7.3-17.8c0-6.7-2.6-13.1-7.3-17.8C68.8,31.5,67.7,31.5,67.1,32.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8,24.7L36,38.5h-9.9c-1.6,0-2.8,1.3-2.8,2.8v17.3c0,1.6,1.3,2.8,2.8,2.8H36l12.8,13.9c1.7,1.9,4.9,0.7,4.9-1.9V26.6     C53.7,24,50.5,22.8,48.8,24.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounSoundOff3408642);
export default __webpack_public_path__ + "static/media/noun_sound_off_3408642.bad4feed.svg";
export { ForwardRef as ReactComponent };